import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable,Subscription } from 'rxjs';
import { Events} from 'ionic-angular';
import { first } from 'rxjs/operators';
import { User } from  '../../models/user';
import { Storage } from '@ionic/storage';
import { map } from 'rxjs/operators';
import { DataProvider } from '../data/data';
import { HttpClient } from '@angular/common/http';
import { firestore } from 'firebase';
import * as moment from 'moment';
/*
  Generated class for the HelpProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HelpProvider {

  constructor(private afs: AngularFirestore,private storage: Storage, public events:Events,private http: HttpClient, private dataProvider:DataProvider,private fbStorage: AngularFireStorage) {
    console.log('Hello HelpProvider Provider');
  }


  intializeSubscriptions(){
  	this.events.subscribe('help:getSections', (screenId) => {
       this.getHelpSections(screenId);
    });


    this.events.subscribe('help:getFaqs', () => {
       this.getFAQs();
    });

   this.events.subscribe('help:getSectionContent', (screenFbId,sectionId) => {
       this.getSectionContent(screenFbId,sectionId);
    });
  }

  removeSubscriptions(){
  	 this.events.unsubscribe('help:getSections');
     this.events.unsubscribe('help:getSectionContent');
     this.events.unsubscribe('help:getFaqs');

  }

  async getHelpSections(screenId){
  	let helpScreen;
  	const screens = await this.afs.collection('screens',ref => ref.where('sid', '==', screenId)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
    }))).pipe(first()).toPromise();

  	if(screens && screens[0]){
  		helpScreen = screens[0];
  	}
  	console.log(helpScreen);

  	if(helpScreen && helpScreen.isHelpActive && helpScreen.id){
  		const sections = await this.afs.collection('screens').doc(helpScreen.id).collection('sections',ref => ref.orderBy('order')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
    	}))).pipe(first()).toPromise();

    	this.events.publish('help:sections',screenId,helpScreen.id,true,sections);
  	}
  	else{
  		this.events.publish('help:sections',screenId,'',false,[]);
  	}

  }

  async getSectionContent(screenFbId,sectionId){
     const content:any = await this.afs.collection('screens').doc(screenFbId).collection('sections').doc(sectionId).collection('components',ref => ref.orderBy('order')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
      }))).pipe(first()).toPromise();

     this.events.publish('help:sectionContent',content);
  }

  async getFAQs(){
    console.log("Getting faqs");

     const content:any = await this.afs.collection('faqs').snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
      }))).pipe(first()).toPromise();

     this.events.publish('help:faqContent',content);

     console.log(content);
  }

}



// WEBPACK FOOTER //
// ./src/providers/help/help.ts